import classnames from 'classnames'
import styles from './ClearButton.module.css'

const ClearButton = ({ resetFilter, isInModal }) => (
  <button
    className={classnames(styles.clearButton, {
      [`${styles.sidebarColors}`]: !isInModal,
    })}
    aria-label="rensa alla filter"
    data-trk="filter-reset-button"
    onClick={resetFilter}
    type="button"
  >
    Rensa alla filter
  </button>
)

export default ClearButton
